"use strict";
var FilterExpressionHelper = (function () {
    function FilterExpressionHelper(expressionHelperUtilities) {
        this.utilities = expressionHelperUtilities;
    }
    FilterExpressionHelper.prototype.getFilterExpressions = function (options) {
        var filterExpressions = this.getContextFilterExpressions(options);
        var filterExpressionsWithExternalContent = this.appendExternalContentToExpression(filterExpressions, options);
        return filterExpressionsWithExternalContent;
    };
    ;
    FilterExpressionHelper.prototype.getContextFilterExpressions = function (options) {
        var expression = "";
        var filterExpressions = [];
        if (options.filterResultsOnCurrentCulture) {
            var clientLanguageFilterExpression = this.utilities.getFilterExpression(options.clientLanguageFieldName, options.clientLanguageName);
            filterExpressions.push(clientLanguageFilterExpression);
        }
        if (options.filterResultOnLatestVersion) {
            var latestVersionFilterExpression = this.utilities.getFilterExpression(options.latestVersionFieldName, "1");
            filterExpressions.push(latestVersionFilterExpression);
        }
        if (filterExpressions.length > 0) {
            var filterExpression = filterExpressions.join(" ").replace(/^\s+|\s+$/g, "");
            expression = "(" + filterExpression + ")";
        }
        return expression;
    };
    FilterExpressionHelper.prototype.appendExternalContentToExpression = function (expression, options) {
        var newExpression = expression;
        if (this.hasExternalContentSpecified(options)) {
            var expressions = [expression];
            var externalSources = this.getAllExternalSources(options, options);
            if (externalSources.length > 0) {
                expressions.push(this.utilities.getExternalSourcesExpression(externalSources));
            }
            var externalCollections = this.getAllExternalCollections(options, options);
            if (externalCollections.length > 0) {
                expressions.push(this.utilities.getExternalCollectionsExpression(externalCollections));
            }
            newExpression = "(" + expressions.join(" OR ") + ")";
        }
        return newExpression;
    };
    ;
    FilterExpressionHelper.prototype.getAllExternalSources = function (externalSourcesOptions, externalContentFromCurrentTabOptions) {
        var externalSources = [];
        externalSources.push.apply(externalSources, externalSourcesOptions.externalSources);
        externalSources.push.apply(externalSources, externalContentFromCurrentTabOptions.externalSourcesFromCurrentTab);
        return externalSources;
    };
    FilterExpressionHelper.prototype.getAllExternalCollections = function (externalCollectionsOptions, externalContentFromCurrentTabOptions) {
        var externalSources = [];
        externalSources.push.apply(externalSources, externalCollectionsOptions.externalCollections);
        externalSources.push.apply(externalSources, externalContentFromCurrentTabOptions.externalCollectionsFromCurrentTab);
        return externalSources;
    };
    FilterExpressionHelper.prototype.hasExternalContentSpecified = function (options) {
        return options.externalCollections.length > 0 ||
            options.externalSources.length > 0 ||
            options.externalSourcesFromCurrentTab.length > 0 ||
            options.externalCollectionsFromCurrentTab.length > 0;
    };
    ;
    return FilterExpressionHelper;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FilterExpressionHelper;



//////////////////
// WEBPACK FOOTER
// ./Base/Rules/FilterExpressionHelper.js
// module id = 10
// module chunks = 0